// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_727d4a33","title":"rdg_2b4a5c1b","list":"rdg_6d119b31","productItem":"rdg_50cfc314","lineItem":"rdg_14300895"};